import { render, staticRenderFns } from "./warning-manage-edit.vue?vue&type=template&id=dc533f48&scoped=true&"
import script from "./warning-manage-edit.vue?vue&type=script&lang=js&"
export * from "./warning-manage-edit.vue?vue&type=script&lang=js&"
import style0 from "./warning-manage-edit.vue?vue&type=style&index=0&id=dc533f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc533f48",
  null
  
)

export default component.exports